"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = require("../../../../../common/js/BaseComponent");
var ProductsList = /** @class */ (function (_super) {
    __extends(ProductsList, _super);
    function ProductsList($view) {
        var _this = _super.call(this, $view) || this;
        _this.initListeners();
        return _this;
    }
    ProductsList.prototype.initListeners = function () {
        /*  this.$view.find("a.page-link").on("click", async (e) => {
              console.log('ssss');
              $('body').scrollTop(0);
              e.preventDefault();
          });*/
    };
    return ProductsList;
}(BaseComponent_1.default));
exports.default = ProductsList;
